import React from "react"
import { SystemMessageProvider } from "@gorilla-technologies/customer-ui"
import { WalletProvider, MintbaseApolloProvider } from "../providers"

export function RootLayout({ children }) {
  return (
    <MintbaseApolloProvider>
      <WalletProvider apiKey={process.env.GATSBY_MINTBASE_API_KEY}>
        <SystemMessageProvider offsetTop={72}>{children}</SystemMessageProvider>
      </WalletProvider>
    </MintbaseApolloProvider>
  )
}
